<template>
  <section class="main-content">

    <section class="main-content__full section">
      <header class="section__header">
        <h1 class="section__title">Browse formats</h1>
        <section class="section__header__area">
          <form class="search">
            <input-search @submit.prevent placeholder="Search formats"></input-search>
          </form>
        </section>
      </header>
    </section>

    <aside class="main-content__side section">
      <categories-listing class="section__content categories"></categories-listing>
    </aside>

    <section data-v-home-step="1" class="main-content__main section">
      <format-listing :formats="formats" class="section__content formats formats--list"></format-listing>
    </section>
  </section>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    formats(){
      return this.$store.getters['formats/formats']
    }
  },
  beforeDestroy () {
    if (this.$tours['home_tour'].isRunning) {
      this.$tours['home_tour'].stop();
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.$store.state.me.errors !== 'unauthorized') {
        let homeTour = this.$store.state.preferences['home_tour'];
        if (!homeTour || homeTour !== 'finished') {
          //this.$tours['home_tour'].start();
        }
      }
      FS.event('Viewing Formats', {
        category_name: 'Home',
        category_id: 0
      });
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/index';
</style>



// WEBPACK FOOTER //
// src/components/Home.vue